import {
  ClearButtonBehaviour,
  DateInput,
  DateInputProps,
} from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { DateFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import UpdaterButton from './UpdaterButton';

interface Props
  extends
    Pick<TFormControlConnectorProps, 'areHintsShown' | 'onRunSingleUpdater'>,
    Pick<DateInputProps, 'onChange' | 'onChanged' | 'onSubmit'> {
  control: DateFormControlViewModel;
}

const FormDateInputControl: React.FC<Props> = ({
  areHintsShown,
  control,
  onChange,
  onChanged,
  onRunSingleUpdater,
  onSubmit,
}) => (
  <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
    <DateInput
      delimiter={control.delimiter}
      disabled={control.disabled}
      format={control.format}
      invalid={control.invalid}
      name={control.name}
      onChange={onChange}
      onChanged={onChanged}
      onSubmit={onSubmit}
      readOnly={control.readonly}
      required={control.required}
      truncTo={control.truncTo}
      value={control.value}
      withClearButton={ClearButtonBehaviour.NONE}
      endSlot={
        control.updater ? (
          <UpdaterButton control={control} updater={onRunSingleUpdater} />
        ) : undefined
      }
    />
  </FormLabeledInputControl>
);

export default FormDateInputControl;
